<template>
  <div class="statusIndicator">
    <div
      class="status-indicator"
      v-if="hasActiveStatus"
      @click="$router.push('/console/podExample')"
    >
      <transition name="status-fade" mode="out-in">
        <div :key="currentStatusIndex" class="status-item">
          <div :class="`breathing-dot ${currentStatus.type}`"></div>
          <span class="status-text">{{ currentStatus.text }}</span>
          <div v-if="currentStatus.type == 'running'" class="statusCont">
            <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>计费中</span>
          </div>
          <div class="status-count">{{ currentStatus.count }}</div>
        </div>
      </transition>
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  name: "statusIndicator",
  data() {
    return {
      // 状态计数
      runningCount: 0,
      startingCount: 0,
      stoppingCount: 0,
      // 状态更新定时器
      statusTimer: null,
      // 状态切换相关
      currentStatusIndex: 0,
      statusSwitchTimer: null,
    };
  },
  watch: {},
  props: {},
  created() {
    this.getStatusCount();
  },
  mounted() {
    // 定时更新状态数据
    this.statusTimer = setInterval(() => {
      this.getStatusCount();
    }, 5000);

    // 定时切换状态显示
    this.statusSwitchTimer = setInterval(() => {
      this.switchStatus();
    }, 5000); // 每5秒切换一次
  },
  beforeUnmount() {
    // 清除定时器
    if (this.statusTimer) {
      clearInterval(this.statusTimer);
      this.statusTimer = null;
    }
    if (this.statusSwitchTimer) {
      clearInterval(this.statusSwitchTimer);
      this.statusSwitchTimer = null;
    }
  },
  computed: {
    // 获取有效的状态列表（数量大于0的）
    activeStatusList() {
      const statusList = [
        { type: "running", text: "运行中", count: this.runningCount },
        { type: "starting", text: "开机中", count: this.startingCount },
        { type: "stopping", text: "关机中", count: this.stoppingCount },
      ];
      return statusList.filter((status) => status.count > 0);
    },
    // 是否有活跃状态
    hasActiveStatus() {
      return this.activeStatusList.length > 0 && this.token && this.user;
    },
    // 当前显示的状态
    currentStatus() {
      if (this.activeStatusList.length === 0) {
        return { type: "running", text: "运行中", count: 0 };
      }
      return this.activeStatusList[
        this.currentStatusIndex % this.activeStatusList.length
      ];
    },
  },
  methods: {
    // 获取状态计数
    getStatusCount() {
      if (!this.token || !this.user) {
        return;
      }
      this.$http
        .POST(this.$manageUrl.instanceStatusStats, {})
        .then((res) => {
          if (res) {
            const stats = res.result.stats;
            this.runningCount = stats.running; // 运行中
            this.startingCount = stats.boot_in_progress; // 开机中
            this.stoppingCount = stats.shutdown_in_progress; // 关机中
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    // 切换状态显示
    switchStatus() {
      if (this.activeStatusList.length > 1) {
        this.currentStatusIndex++;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.statusIndicator {
  // 状态切换过渡动画
  .status-fade-enter-active,
  .status-fade-leave-active {
    transition: all 0.3s ease;
  }
  .status-fade-enter-from {
    opacity: 0;
    // transform: translateY(10px);
  }
  .status-fade-leave-to {
    opacity: 0;
    // transform: translateY(-10px);
  }
  // 呼吸动效动画
  // 运行中动画
  @keyframes breathing {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.7);
    }
    50% {
      transform: scale(1.2);
      box-shadow: 0 0 0 4px rgba(82, 196, 26, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
    }
  }
  // 开机中动画
  @keyframes breathingStarting {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(250, 173, 20, 0.7);
    }
    50% {
      transform: scale(1.2);
      box-shadow: 0 0 0 4px rgba(250, 173, 20, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(250, 173, 20, 0);
    }
  }
  // 关机中动画
  @keyframes breathingStopping {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.7);
    }
    50% {
      transform: scale(1.2);
      box-shadow: 0 0 0 4px rgba(255, 77, 79, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
    }
  }
  // 状态指示器
  .status-indicator {
    display: flex;
    align-items: center;
    margin-right: 5px;
    background: rgb(30 41 59);
    padding: 5px 10px;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 8px;
    cursor: pointer;
    .status-item {
      line-height: 1.2;
      display: flex;
      align-items: center;
      gap: 6px;
      .breathing-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        animation: breathing 2s ease-in-out infinite;
        &.running {
          background-color: #52c41a;
          box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.7);
          animation: breathing 2s ease-in-out infinite;
        }
        &.starting {
          background-color: #faad14;
          box-shadow: 0 0 0 0 rgba(250, 173, 20, 0.7);
          animation: breathingStarting 1.5s ease-in-out infinite;
        }
        &.stopping {
          background-color: #ff4d4f;
          box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.7);
          animation: breathingStopping 1.5s ease-in-out infinite;
        }
      }
      .status-text {
        font-size: 14px;
        color: white;
        white-space: nowrap;
      }
      @keyframes slideUp {
        0% {
          opacity: 0.8;
        }
        30% {
          opacity: 1;
        }
        70% {
          opacity: 1;
        }
        100% {
          opacity: 0.8;
        }
      }
      .statusCont {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        border-radius: 10px;
        background-image: linear-gradient(to right, #facc15, #f97316);
        padding: 2px 6px;
        animation: slideUp 2s linear infinite;
        svg {
          width: 10px;
        }
        span {
          font-size: 0.7em;
        }
      }
      .status-count {
        height: 20px;
        padding: 0 7px;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}
</style>